import { Component, OnInit, Inject, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnessaTranslationInterface } from '../../../../models/interfaces/anessa-translation.interface';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { takeUntil } from 'rxjs/operators';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';
import { ResultCategory } from '../scenario-results.component';

@Component({
  selector: 'app-scenario-result-dropdown-search',
  templateUrl: './result-dropdown-search.component.html',
  styleUrls: ['./result-dropdown-search.component.scss']
})
export class ScenarioResultDropdownSearchComponent extends UserpilotReloader implements OnInit, OnDestroy, AnessaTranslationInterface {
  searchData: ResultDropdownSearchData[] = [];
  filteredSearchData: ResultDropdownSearchData[] = [];
  /** The search criteria entered by the user */
  searchCriteria = '';
  trigger?: string;
  onDestroyNotifier = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<ScenarioResultDropdownSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ResultDropdownSearchData[],
              private translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.searchData = this.data;
    this.filteredSearchData = this.searchData;
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(language => {
        this.trigger = language;
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  /**
   * closes the search pop-up with the currently selected result
   * @param item is the selected result item
   */
  onItemClick(item: ResultDropdownSearchData) {
    this.dialogRef.close(item);
  }

  /**
   * Updates the filtered search data array.
   */
  onSearchChange() {
    // done in an async function call to avoid the delay caused by the function being processes
    const asyncFunction = () => {
      if (!this.searchData) {
        return;
      }
      let search = this.searchCriteria;
      if (!search) {
        this.filteredSearchData = this.searchData.slice();
        return;
      } else {
        search = search.toLowerCase();
      }

      this.filteredSearchData = this.searchData.filter(
        input => {
          if (input && input.display) {
            return input.display.toLowerCase().indexOf(search) > -1;
          }
        }
      );
    };
    asyncFunction();
  }

  /**
   * closes the search pop-up with no data being returned
   */
  onCloseClick() {
    this.dialogRef.close();
  }
}

interface ResultDropdownSearchData {
  display: string;
  cat: ResultCategory;
  group: string;
  name: string;
};